require('../../modules/es.typed-array.uint16-array');
require('./methods');
var global = require('../../internals/global');

module.exports = global.Uint16Array;
